"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Article = _interopRequireDefault(require("@insided/destination/icons/Article"));

var _Discussion = _interopRequireDefault(require("@insided/destination/icons/Discussion"));

var _Idea = _interopRequireDefault(require("@insided/destination/icons/Idea"));

var _Answer = _interopRequireDefault(require("@insided/shared/icons/Answer"));

/**
 * Icons mapping for different content types
 * viewBox='2 2 20 20' crops the icon to show only the inner symbol without border (equivalent to withoutBorder={true})
 */
var icons = {
  question: (0, _preact.h)(_Question.default, {
    width: 13.33,
    className: "icon--question-circle",
    height: 13.33,
    viewBox: "2 2 20 20"
  }),
  article: (0, _preact.h)(_Article.default, {
    width: 13.33,
    height: 13.33,
    viewBox: "2 2 20 20"
  }),
  conversation: (0, _preact.h)(_Discussion.default, {
    width: 13.33,
    height: 13.33,
    viewBox: "2 2 20 20"
  }),
  productUpdate: (0, _preact.h)(_Article.default, {
    width: 13.33,
    height: 13.33,
    viewBox: "2 2 20 20"
  }),
  event: (0, _preact.h)(_Discussion.default, {
    width: 13.33,
    height: 13.33,
    viewBox: "2 2 20 20"
  }),
  idea: (0, _preact.h)(_Idea.default, {
    width: 13.33,
    height: 13.33,
    viewBox: "2 2 20 20"
  })
};
/**
 * Component that renders the appropriate icon based on content type
 */

var ContentTypeIcon = function ContentTypeIcon(_ref) {
  var contentType = _ref.contentType,
      hasBestAnswer = _ref.hasBestAnswer;

  if (hasBestAnswer) {
    return (0, _preact.h)(_Answer.default, {
      width: 13.33,
      height: 13.33,
      className: "icon--thread-solved"
    });
  }

  return icons[contentType];
};

var _default = ContentTypeIcon;
exports.default = _default;